<template>
  <div class="question-options">
    <div
      v-for="(option, index) in question.options"
      :class="getOptionClass(option)">
      <choice-option
        :questionIndex="questionIndex"
        :question="question"
        :index="index"
        :option="option"
        :value="selectedOptionId"
        :disabled="disabled"
        :type="question.type">
        <template slot="append">
          <slot name="append"
                :option="option"></slot>
        </template>
      </choice-option>
    </div>
  </div>
</template>

<script>
import ChoiceOption from '@/views/question-review/packages/QuestionOption/ChoiceOption'

export default {
  components: {ChoiceOption},
  mixins: [],
  props: {
    questionIndex: Number,
    question: Object,
    selectedOptionId: Array,
    disabled: Boolean,
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  beforeCreate () {},
  created () {
    this.$nextTick(() => {})
  },
  mounted () {
  },
  methods: {
    ...Vuex.mapActions([]),
    getOptionClass (option) {
      return [
        'question--option',
        this.disabled ? 'disabled' : '',
        this.selectedOptionId.includes(option.id) ? 'selected' : '',
      ]
    },
  },
}
</script>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>



// WEBPACK FOOTER //
// src/views/question-review/packages/QuestionOption/ChoiceOptions.vue